/**
 *  Maps names form Filters.model.ts
 */
export enum FilterName {
  AUTHOR = 'author',
  DATA= 'dataType',
  VARIABLE = 'variable',
  PERIOD = 'period',
  GWL = 'gwl',
  SEASON = 'season',
  SCENARIO = 'scenario',
  GRID_SPACING = 'gridSpacing'
}
